import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase konfigürasyonu - mevcut projenizden alınan bilgiler
const firebaseConfig = {
  apiKey: "AIzaSyD4GY65T8I-qrh1KirFAhIG1t7VUqzaocM",
  authDomain: "myapplication20122023-48eef.firebaseapp.com",
  projectId: "myapplication20122023-48eef",
  storageBucket: "myapplication20122023-48eef.firebasestorage.app",
  messagingSenderId: "356443469714",
  appId: "1:356443469714:android:cbb8d48a4ce1306fe3f34b"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Firebase servislerini export et
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Google provider'ı oluştur
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
